import { ArrowUp } from "lucide-react";
import { Logo } from "./Logo";
import { useSite, scrollToId } from "../lib/site";

export const Footer = () => {
  const { t } = useSite();
  return (
    <footer className="relative overflow-hidden pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-8">
          <Logo />
          <button onClick={() => scrollToId("top")} data-testid="footer-back-to-top" className="inline-flex items-center gap-2 text-sm text-[var(--muted)] hover:text-[var(--gold)] transition-colors w-fit">
            <ArrowUp className="w-4 h-4" />{t.footer.top}
          </button>
        </div>
        <p className="f-display outline-text select-none text-[22vw] leading-none mt-12 text-center" dir="ltr" aria-hidden="true">STRAVION</p>
        <p className="mt-6 text-xs text-[var(--muted)]" data-testid="footer-copyright">© 2026 Stravion Advisory FZE. {t.footer.rights}</p>
      </div>
    </footer>
  );
};
